module.exports = __webpack_public_path__ + "static/media/hero-mobile.4eae6605.jpg";